import comboJson from "./combo-rules-v1.json";
import masterJson from "./wmlsti-master-v5.1.json";
import lockedConfigJson from "./wmlsti-content-config-v4-locked.json";
import type { ComboRule, InternalDimension, PersonaId, WmlstiMaster } from "../types";

type HighLow = "高" | "低";

export interface LockedPersonaType {
  group: string;
  name: string;
  conditions: Record<"相信" | "不服" | "眷恋" | "远方", HighLow>;
  one_liner: string;
  summary: string;
  friction: string;
  internal_id: `类型${string}`;
}

export interface LockedContentConfig {
  version: string;
  dimensions: Record<InternalDimension, string>;
  types: LockedPersonaType[];
  albums: Array<{
    album: string;
    songs: Array<{ title: string; weights: Record<InternalDimension, number> }>;
  }>;
  normalization: {
    percentile_lookup: Record<InternalDimension, Record<string, number>>;
  };
}

export const master = masterJson as WmlstiMaster;
export const comboRules = comboJson as unknown as ComboRule[];
export const contentConfig = lockedConfigJson as LockedContentConfig;
export const personaTypeNames = master.type_names as Record<PersonaId, string>;

export const songsByAlbum = new Map(
  master.completed_albums.map((album) => [album, master.songs.filter((song) => song.album === album)]),
);

export function songKey(album: string, song: string) {
  return `${album}\u0000${song}`;
}

export const songByKey = new Map(master.songs.map((song) => [songKey(song.album, song.song), song]));
